import script from "./NoteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoteModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoteModal.vue?vue&type=style&index=0&id=dfde157c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfde157c"]])

export default __exports__